/**
 * NoAccessView — la pantalla existe, pero el tier del usuario no la alcanza.
 *
 * No es un error: es una denegación esperada (el `external` que escribe
 * `/templates` en la barra, o una lectura que el backend negó con
 * `403 FORBIDDEN_TIER`). Por eso no usa `ErrorBox` y ofrece salida a la home.
 *
 * Solo presenta. No toca la caché ni la sesión: retirar datos o refrescar el
 * tier no es responsabilidad de esta vista.
 *
 * `NoAccessNotice` es el mismo aviso sin la página: lo usa una vista que
 * conserva su encabezado y solo sustituye el contenido denegado (la base de
 * conocimiento del tenant, dentro de `SourcesPanel`).
 */

import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { ScrollPage } from '../components/shell/ScrollPage'

export function NoAccessView() {
  return (
    <ScrollPage centered>
      <NoAccessNotice />
    </ScrollPage>
  )
}

export function NoAccessNotice() {
  const { t } = useTranslation('common')

  return (
    <section className="w-full max-w-md rounded-md border border-line bg-surface p-8">
      <p className="font-mono text-xs uppercase tracking-wide text-ink-subtle">
        {t('no_access.code')}
      </p>
      <h1 className="mt-3 font-display text-2xl text-ink">{t('no_access.title')}</h1>
      <p className="mt-2 font-body text-sm text-ink-muted">{t('no_access.body')}</p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center justify-center rounded-md
                   bg-brand px-5 py-2.5 font-ui text-sm text-canvas
                   transition-colors hover:bg-brand-deep
                   focus:outline-none focus:ring-2 focus:ring-brand/40"
      >
        {t('no_access.back_home')}
      </Link>
    </section>
  )
}
